
import React from "react";
import { FileText, User, Calendar, ExternalLink, Trash2 } from "lucide-react";

export const UploadsGridView = ({ history, onFileClick, onRemoveFile }) => {
  if (!history || history.length === 0) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-1">
      {history.map((item) => (
        <div 
          key={item._id} 
          onClick={() => onFileClick(item)}
          className="card rounded-none group hover:border-brand-blue transition-all cursor-pointer hover:shadow-lg bg-white overflow-hidden flex flex-col"
        >
          {/* File Icon Header */}
          <div className="p-4 bg-slate-50 border-b border-slate-100 flex items-center justify-between group-hover:bg-blue-50 transition-colors">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white shadow-sm border border-slate-200 text-blue-600 rounded-none flex items-center justify-center group-hover:border-brand-blue group-hover:text-brand-blue transition-all">
                <FileText size={20} />
              </div>
              <div className="text-[10px] font-medium text-slate-400 uppercase tracking-widest">{item._id.slice(-6)}</div>
            </div>
            <button 
              onClick={(e) => { e.stopPropagation(); onRemoveFile && onRemoveFile(item._id); }}
              className="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors opacity-0 group-hover:opacity-100"
              title="Remove from view"
            >
              <Trash2 size={16} />
            </button>
          </div>

          <div className="p-4 space-y-3 flex-1">
            <div>
              <h3 className="font-medium text-brand-dark group-hover:text-brand-blue transition-colors line-clamp-1 flex items-center gap-1.5">
                {item.filename}
              </h3>
              <p className="text-[10px] text-slate-400 mt-0.5">Import Session</p>
            </div>

            <div className="grid grid-cols-2 gap-2">
              <div className="p-2 bg-slate-50 rounded-none">
                <p className="text-[9px] font-medium text-slate-400 uppercase tracking-tighter">SUCCESS</p>
                <p className="text-sm font-medium text-brand-blue">{item.successCount}</p>
              </div>
              <div className="p-2 bg-slate-50 rounded-none">
                <p className="text-[9px] font-medium text-slate-400 uppercase tracking-tighter">TOTAL</p>
                <p className="text-sm font-medium text-slate-700">{item.rowCount}</p>
              </div>
            </div>

            <div className="pt-2 border-t border-slate-50 flex items-center justify-between text-[11px] text-slate-500 font-medium">
              <div className="flex items-center gap-1.5">
                <Calendar size={12} className="text-slate-400" />
                {new Date(item.createdAt).toLocaleDateString()}
              </div>
              <div className="flex items-center gap-1.5">
                <User size={12} className="text-slate-400" />
                {item.importedBy?.name?.split(' ')[0] || "System"}
              </div>
            </div>
          </div>

          <div className="p-2 bg-slate-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-1 text-[10px] font-medium text-brand-blue uppercase tracking-widest">
            <ExternalLink size={10} /> View Details
          </div>
        </div>
      ))}
    </div>
  );
};
